import React from 'react';

import ContactOption from '../contact-option/contact-option';

import type { ContactOptions as Props } from './contact-options.types';
import KindlyTrigger from '../kindly-trigger/kindly-trigger';
import { useSalesforceMessaging } from 'root/client/hooks/use-salesforce-messaging';

const ContactOptions: React.FunctionComponent<Props> = ({
  chat,
  deprecatedChat,
  entries,
}) => {
  if (deprecatedChat) {
    useSalesforceMessaging(
      deprecatedChat.esw,
      deprecatedChat.init,
      deprecatedChat.settings,
      deprecatedChat.preChat,
    );
  }

  return (
    <div className="contact-options">
      {chat ? <KindlyTrigger botKey={chat.botKey} /> : null}
      {entries.map(entry => (
        <ContactOption {...entry} key={entry.key} />
      ))}
    </div>
  );
};

export default ContactOptions;
